export function isUnsupportedOfficeWebview(userAgent: string): boolean {
  // Fluent UI React v9 uses modern JS features that are not supported in:
  // - Trident (Internet Explorer)
  // - EdgeHTML (Edge Legacy)
  //
  // Office add-ins hosted in those engines cannot run the task pane reliably.
  // We keep this check minimal and deterministic so it is CSP-friendly.
  return userAgent.includes("Trident") || userAgent.includes("Edge");
}

export function applyUnsupportedWebviewBanner(): void {
  try {
    const ua = navigator.userAgent || "";
    if (!isUnsupportedOfficeWebview(ua)) {
      return;
    }

    const tridentMessage = document.getElementById("tridentmessage");
    const normalContainer = document.getElementById("container");

    if (tridentMessage) {
      tridentMessage.style.display = "block";
    }
    if (normalContainer) {
      normalContainer.style.display = "none";
    }
  } catch {
    // If anything goes wrong, fail open (attempt to render the app).
  }
}
